import React                from "react";
import PropTypes            from "prop-types";
import Store                from "Dashboard/Core/Store";
import Action               from "Dashboard/Core/Action";
import Utils                from "Dashboard/Utils/Utils";
import useList              from "Dashboard/Hooks/List";

// Components
import CourtEdit            from "./CourtEdit";

// Dashboard
import Main                 from "Dashboard/Components/Core/Main";
import Content              from "Dashboard/Components/Core/Content";
import Header               from "Dashboard/Components/Header/Header";
import ActionList           from "Dashboard/Components/Header/ActionList";
import Table                from "Dashboard/Components/Table/Table";
import TableHead            from "Dashboard/Components/Table/TableHead";
import TableBody            from "Dashboard/Components/Table/TableBody";
import TableRow             from "Dashboard/Components/Table/TableRow";
import TableHeader          from "Dashboard/Components/Table/TableHeader";
import TableCell            from "Dashboard/Components/Table/TableCell";
import TablePaging          from "Dashboard/Components/Table/TablePaging";
import TableActionList      from "Dashboard/Components/Table/TableActionList";
import TableAction          from "Dashboard/Components/Table/TableAction";
import DeleteDialog         from "Dashboard/Components/Dialogs/DeleteDialog";



/**
 * The Court List
 * @param {Object} props
 * @returns {React.ReactElement}
 */
function CourtList(props) {
    const { type } = props;
    const { fetch, load } = useList("court", type);

    const data = Store.useState("court");
    const { loading, canEdit, list, total, activityID, sort } = data;

    const { deleteElem } = Store.useAction("court");

    // The Current State
    const [ action, elemID, startAction, endAction ] = Action.useActionID();


    // Handles the Edit Submit
    const handleEdit = () => {
        endAction();
        fetch();
    };

    // Handles the Delete Submit
    const handleDelete = async () => {
        endAction();
        const result = await deleteElem(elemID);
        if (result.success) {
            fetch();
        }
    };


    // Do the Render
    const elemName = Utils.getValue(list, "courtID", elemID, "name");

    return <Main>
        <Header message="COURTS_NAME" icon="court">
            <ActionList data={data} onAction={startAction} />
        </Header>
        <Content>
            <Table
                fetch={load}
                sort={sort}
                none="COURTS_NONE_AVAILABLE"
                isLoading={loading}
            >
                <TableHead>
                    <TableHeader field="fullName" message="GENERAL_NAME"   isTitle bigMobile />
                    <TableHeader field="status"   message="GENERAL_STATUS" maxWidth="100" align="center" />
                </TableHead>
                <TableBody>
                    {list.map((elem) => <TableRow key={elem.courtID} elemID={elem.courtID}>
                        <TableCell message={elem.fullName}   />
                        <TableCell message={elem.statusName} textColor={elem.statusColor} />
                    </TableRow>)}
                </TableBody>
                <TablePaging total={total} />
                <TableActionList onAction={startAction} canEdit={canEdit}>
                    <TableAction action="EDIT"   message="COURTS_EDIT_TITLE"   />
                    <TableAction action="DELETE" message="COURTS_DELETE_TITLE" />
                </TableActionList>
            </Table>
        </Content>

        <CourtEdit
            open={action.isVCE}
            elemID={elemID}
            activityID={activityID}
            onSubmit={handleEdit}
            onClose={endAction}
        />
        <DeleteDialog
            open={action.isDelete}
            title="COURTS_DELETE_TITLE"
            message="COURTS_DELETE_TEXT"
            content={elemName}
            onSubmit={handleDelete}
            onClose={endAction}
        />
    </Main>;
}

/**
 * The Property Types
 * @typedef {Object} propTypes
 */
CourtList.propTypes = {
    type : PropTypes.string.isRequired,
};

export default CourtList;
